<mat-form-field class="search with-prefix" [class.active]="isSearchActive$ | async" floatLabel="never">
    <mat-icon matPrefix>search</mat-icon>
    <input
        #inputField
        matInput
        autocomplete="off"
        name="search"
        placeholder="Search"
        value=""
        (keyup.enter)="openCurrentSelection()"
        (keyup.esc)="inputField.blur()"
        [matAutocomplete]="searchResultsAuto"
        [(ngModel)]="text"
        (ngModelChange)="search.search($event)"
        (paste)="onPaste($event)"
    />
    <mat-autocomplete
        #searchResultsAuto="matAutocomplete"
        class="global-search-results"
        [panelWidth]="inputField.width"
        [autoActiveFirstOption]="true"
        (optionSelected)="openCurrentSelection()"
    >
        <mat-option *ngFor="let res of search.results$ | async" (onSelectionChange)="onSelectionChange($event)">
            <!-- NOTE atm option should have an element with "badge" class inside it-->
            <ce-station-badge
                *ngIf="res.type === 'station'"
                [station]="res.station?.data.station"
                [globalSearchStation]="res.globalSearchStation"
            >
            </ce-station-badge>
            <ce-connector-badge
                *ngIf="res.type === 'connector'"
                [connector]="res.connector"
                [globalSearchConnector]="res.globalSearchConnector"
                [location]="
                    res.station?.data?.station?.location?.name ||
                    res.station?.data?.station?.name ||
                    res.globalSearchConnector?.location?.locationName ||
                    res.globalSearchConnector?.station?.stationName
                "
            >
            </ce-connector-badge>
            <ce-ticket-badge *ngIf="res.type === 'ticket'" [ticket]="res.ticket"></ce-ticket-badge>
            <ce-organization-badge
                *ngIf="res.type === 'organization'"
                [globalSearchOrganization]="res.globalSearchOrganization"
            ></ce-organization-badge>
            <ce-location-badge
                *ngIf="res.type === 'location'"
                [location]="res.location"
                [globalSearchLocation]="res.globalSearchLocation"
            ></ce-location-badge>
            <div *ngIf="res.type === 'no_results'">No results</div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
